import { Component, Input, OnInit } from '@angular/core';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input()
  title: string;
  @Input()
  icon: string;
  private mobile: boolean;

  constructor(private menuService: MenuService) {
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
    }
  }

  ngOnInit() {
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.menuService.toggleMenu();
  }
}
